import authService from "./AuthService";
import franquiasService from "./FranquiasService";
import usuariosService from "./UsuariosService";
import recursosHumanosService from "./RecursosHumanosService";
import rolesService from "./RolesService";
import appConfigurationService from "./AppConfigurationService";
import colaboradorPontosService from "./ColaboradorPontosService";
import notificacoesService from "./NotificacoesService";
import colaboradorAvisoService from "./ColaboradorAvisoService";
import anosService from "./AnosService";
import calendarioLetivoService from "./CalendarioLetivoService";
import eventoCalendarioLetivoService from "./EventoCalendarioLetivoService";
import chatService from "./ChatService";
import relatoriosService from "./RelatoriosService";
import cepService from "./CepService";
import bancoHorasService from "./BancoHorasService";
import colaboradorFeriasService from "./ColaboradorFeriasService";
import novidadesService from "./NovidadesService";

const $services = {
  authService,
  franquiasService,
  usuariosService,
  recursosHumanosService,
  rolesService,
  appConfigurationService,
  colaboradorPontosService,
  notificacoesService,
  colaboradorAvisoService,
  anosService,
  calendarioLetivoService,
  eventoCalendarioLetivoService,
  chatService,
  relatoriosService,
  cepService,
  bancoHorasService,
  colaboradorFeriasService,
  novidadesService,
};

export default $services;
